import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import KpiBtn from '../../objects/kpi/KpiButton';
import BadgeBtn from '../../objects/badges/BadgesButton';
import MenuBtn from '../../dialogs/mainMenu/MenuButton';
import ResourcesBtn from '../../dialogs/resources/ResourcesBtn';
import BackBtn from '../../buttons/BackButton';
import ExitBtn from '../../buttons/ExitButton';
import HomeBtn from '../../buttons/HomeHeaderButton';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as badgeHelper from '../../../helpers/badgeHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as localeStorage from '../../../localStorage/localStorage';
import * as actionTypes from '../../../actions/actionTypes';
import {PERFORMANCE_CONFIG} from '../../../models/dialogModels';
import * as enviromentHelper from '../../../helpers/environmentHelper';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as kpiModels from '../../../models/kpiModels';
import * as navigationConstants from '../../../constants/navigationConstants';
import * as componentConstants from '../../../constants/componentConstants';
import * as appConstants from '../../../constants/appConstants';

class ScenarioBiteHeaderMobile extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            env: enviromentHelper.getEnvironment(),
            bite: this.props.bite,
            titles: this.props.titles,
            locale: appHelper.getLocalData(this.props.bite),
            showMenu: appHelper.biteHasScreensVisibleToMenu(this.props.bite.screens),
            showResources: appHelper.isDefined(localeStorage.resources) && localeStorage.resources.length > 0,
            //kpis
            showBadges: badgeHelper.biteHasvisibleBadges(this.props.bite),
            showKpis: kpiHelper.biteHasVisibleKpis(this.props.bite),
            showToolTipKpis: false,
            kpiParams: {
                bite_id: this.props.bite.bite_id,
                showTitle: true,
                displayState: kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL

            },
            badgeParams: {
                bite_id: this.props.bite.bite_id,
                showTitle: true,
            },
            showBackBtn: appHelper.isDefined(this.props.contentData.experience) ? this.props.contentData.experience.include_back_button : false,
            showExitBtn: appHelper.isDefined(this.props.contentData.experience) ? this.props.contentData.experience.include_exit_button : false,
            ariaHasPopup: true,
            setLocale: false,
            badges_label: appHelper.getLocaleString("badges_label"),
            performance_btn_label: appHelper.getLocaleString("performance_btn_label"),
            performance_and_badges_label: appHelper.getLocaleString("performance_and_badges_label"),
            showLocaleTitle: false,
            assets: {
                logo: {
                    src: "",
                }
            },
        };
        this.componentWatcher = this.componentWatcher.bind(this);
        this.getPageProgressClass = this.getPageProgressClass.bind(this);
        //MENU
        this.getMenuDisabled = this.getMenuDisabled.bind(this);
        //RESOURCES
        this.getResourcesDisabled = this.getResourcesDisabled.bind(this);
        //KPIs
        this.geKpiBtnDisabled = this.geKpiBtnDisabled.bind(this);
        this.openPerformanceDialog = this.openPerformanceDialog.bind(this);
        this.hideOnMobile = this.hideOnMobile.bind(this);
        this.setBtnState = this.setBtnState.bind(this);
        //this.jumpToBite = this.jumpToBite.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.getItemCount = this.getItemCount.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.showHomeBtn = this.showHomeBtn.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.componentWatcher);
        this.setBtnState();
        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.titles !== nextProps.titles) {
            this.setState({titles: Object.assign({}, nextProps.titles)});
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                badges_label: appHelper.getLocaleString("badges_label"),
                performance_btn_label: appHelper.getLocaleString("performance_btn_label"),
                performance_and_badges_label: appHelper.getLocaleString("performance_and_badges_label"),
                setLocale: true
            });
        }
    }

    componentDidUpdate() {
        if (this.state.setLocale) {
            this.getLocale();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.componentWatcher);
    }

    componentWatcher() {
        let env = enviromentHelper.getEnvironment();
        if (env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation) {
            this.setState({env: env});
        }
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.props.bite);
        this.setState({locale: Object.assign({}, locale), setLocale: false});
    }

    setBtnState() {
        this.setState({
            showBackBtn: appHelper.isDefined(this.props.contentData.experience) ? this.props.contentData.experience.include_back_button : false,
            showExitBtn: appHelper.isDefined(this.props.contentData.experience) ? this.props.contentData.experience.include_exit_button : false
        });
    }

    hideOnMobile() {
        if (this.state.showBadges) {
            if (this.state.showKpis && this.state.env.window.size === "xs" && this.state.env.window.orientation === "portrait") {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }

    }

    getPageProgressClass() {
        let screenId = this.props.trackingData.lesson_location;
        let screenUserData = userDataHelper.getScreenUserData(this.props.userData, screenId);
        if (appHelper.isDefined(screenUserData)) {
            switch (screenUserData.status) {
                case objectConstants.STATUS_NOT_REQUIRED:
                    return objectConstants.CLASS_NOT_REQUIRED;
                case objectConstants.STATUS_IN_PROGRESS:
                    return objectConstants.CLASS_IN_PROGRESS;
                case objectConstants.STATUS_COMPLETE:
                    return objectConstants.CLASS_COMPLETE;
                default:
                    return objectConstants.CLASS_NOT_STARTED;
            }
        } else {
            return objectConstants.CLASS_NOT_STARTED;
        }
    }

    getMenuDisabled() {
        let disabled = false;

        if (this.props.displayResources !== actionTypes.STATUS_CLOSED  /*|| this.props.dialogPopup.render*/ || this.props.assetDialog.render || this.props.screenDialog.render || this.props.dialogPopup.render) {
            disabled = true;
        }
        return disabled;
    }


    getResourcesDisabled() {
        let disabled = false;
        if (this.props.displayMainMenu !== actionTypes.STATUS_CLOSED || this.props.assetDialog.render || this.props.dialogPopup.render) {
            disabled = true;
        }
        return disabled;
    }

    geKpiBtnDisabled() {
        let disabled = false;
        if (this.props.displayResources !== actionTypes.STATUS_CLOSED || this.props.displayMainMenu !== actionTypes.STATUS_CLOSED || this.props.assetDialog.render || this.props.screenDialog.render || this.props.dialogPopup.render) {
            disabled = true;
        }
        return disabled;
    }


    openPerformanceDialog(sourceId) {

        if (!this.geKpiBtnDisabled()) {
            let title = this.state.performance_and_badges_label;
            let childComponents = [];

            if (!this.state.showKpis && this.state.showBadges) {
                title = this.state.badges_label;
            } else if (this.state.showKpis && !this.state.showBadges) {
                title = this.state.performance_btn_label;
            }

            let config = Object.assign({}, PERFORMANCE_CONFIG, {
                title: title,
                sourceId: sourceId
            });


            for (let i = 0; i < config.childComponents.length; i++) {
                let child = config.childComponents[i];
                //console.log(child);
                if (child.id === 'KpiDashboard') {
                    child.componentProps = Object.assign({}, this.state.kpiParams);

                    if (this.state.showKpis) {
                        childComponents = dataHelper.immutablePush(childComponents, child);
                    }
                }
                if (child.id === 'BadgeDashboard') {
                    child.componentProps = Object.assign({}, this.state.badgeParams);
                    if (this.state.showBadges) {
                        childComponents = dataHelper.immutablePush(childComponents, child);
                    }
                }
            }

            config = Object.assign({}, config, {
                childComponents: childComponents
            });

            this.props.actions.setNewDialog(config);
        }
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.openPerformanceDialog();
        }
    }

    getItemCount(){
        let count = 0;
        if(this.state.showKpis){count++;}
        if(this.state.showBadges){count++;}
        if(this.state.showResources){count++;}
        if(this.state.showExitBtn){count++;}

        return `${count}`;
    }

    getAssets(){
        let logoAsset = appHelper.getHeaderLogoAsset(this.props.contentData.experience.header_logo);
        if(appHelper.isDefined(logoAsset)) {
            this.setState({
                assets: Object.assign({}, this.state.assets, {
                    logo: logoAsset
                })
            });
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if(appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    showHomeBtn(position){
        let showHomeBtn = false;
        if((this.props.contentData.experience.bites.length > 1 && this.props.contentData.experience.experience_learning_model === componentConstants.MENU_TYPE_PERSONAL_LEARNING_PLAN && userDataHelper.getBiteStatus(this.props.userData.bites[0]) === objectConstants.STATUS_COMPLETE) && appHelper.isDefined(this.props.contentData.experience.home_position) && this.props.contentData.experience.home_position === position){
            showHomeBtn = true;
        }else if((this.props.contentData.experience.bites.length > 1 && this.props.contentData.experience.experience_learning_model !== componentConstants.MENU_TYPE_PERSONAL_LEARNING_PLAN) && appHelper.isDefined(this.props.contentData.experience.home_position) && this.props.contentData.experience.home_position === position){
            showHomeBtn = true;
        }
        return showHomeBtn;
    }

    render() {
        let rightColItemCount = this.getItemCount();
        return (
            <div className="device-header guroo-header" role="banner" id="scenarioBiteHeader">
                <div className="header-nav-container">
                    <div className="header-left-col">
                        <div className="nav-row">
                            {this.state.showBackBtn || this.showHomeBtn(navigationConstants.HOME_POSITION_LEFT)
                                ?
                                <div className="col-row">
                                    {this.state.showBackBtn
                                        ?
                                    <div className="flex-item text-center">
                                        <BackBtn disabled={this.geKpiBtnDisabled()}/>
                                    </div>
                                        : null
                                    }
                                    {
                                        this.showHomeBtn(navigationConstants.HOME_POSITION_LEFT)
                                            ?
                                            <div className="flex-item text-center">
                                                <HomeBtn/>
                                            </div>
                                            : null
                                    }
                                </div>
                                : null
                            }
                            <div className="col-row">
                                <div className="flex-item text-center">
                                    {this.state.showMenu.toString  && this.props.contentData.experience.include_menu
                                        ? <MenuBtn disabled={this.getMenuDisabled()}/>
                                        : null
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="header-center-col">
                        <div className="nav-row">


                            {(appHelper.isDefined(this.props.contentData.experience.title_position) && this.props.contentData.experience.title_position === navigationConstants.TITLE_POSITION_EXPERIENCE_AND_SCREEN) || !appHelper.isDefined(this.props.contentData.experience.title_position)
                                ?
                                <div className="col-row">
                                    <div className="flex-item">
                                        <div className="truncate-text-container">
                                            <h2 dangerouslySetInnerHTML={{__html: this.state.locale.title}}/>
                                        </div>

                                    </div>
                                </div>
                                :
                                null
                            }
                            {(appHelper.isDefined(this.props.contentData.experience.title_position) && this.props.contentData.experience.title_position === navigationConstants.TITLE_POSITION_EXPERIENCE_ONLY)
                                ?
                                <div className="col-row">
                                    <div className="truncate-text-container">
                                        <h3 dangerouslySetInnerHTML={{__html: this.state.locale.title}}/>
                                    </div>

                                </div>
                                :
                                null
                            }
                            {(appHelper.isDefined(this.props.contentData.experience.title_position) && (this.props.contentData.experience.title_position === navigationConstants.TITLE_POSITION_EXPERIENCE_AND_SCREEN || this.props.contentData.experience.title_position === navigationConstants.TITLE_POSITION_SCREEN_ONLY)) || !appHelper.isDefined(this.props.contentData.experience.title_position)
                                ?
                                <div className="col-row">
                                    <div className="truncate-text-container">
                                        <h3 className={`screen-title ${this.getPageProgressClass()}`}
                                            dangerouslySetInnerHTML={{__html: this.state.titles.screenTitle}}/>
                                    </div>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                    <div className={`header-right-col items-${rightColItemCount}`}>
                        {rightColItemCount > 0
                            ?
                            <div className="col-row">
                                {
                                    this.state.showKpis
                                        ?
                                        <div className="flex-item">
                                            <KpiBtn onClickFunc={this.openPerformanceDialog}
                                                    meterParams={kpiModels.MOBILE_HEADER_KPI_ROTATION_METER_PARAMS}
                                                    bite_id={this.state.bite.bite_id}
                                                    kpis={kpiHelper.getKpis(this.state.bite)}
                                                    disabled={this.geKpiBtnDisabled()}/>
                                        </div>

                                        : null
                                }
                                {
                                    this.state.showBadges
                                        ?
                                        <div className="flex-item">
                                            <BadgeBtn onClickFunc={this.openPerformanceDialog}
                                                      bite_id={this.state.bite.bite_id}
                                                      disabled={this.geKpiBtnDisabled()}/>
                                        </div>

                                        : null
                                }
                                {
                                    this.state.showResources
                                        ?
                                        <div className="flex-item">
                                            <ResourcesBtn disabled={this.getResourcesDisabled()}/>
                                        </div>
                                        : null
                                }
                                {
                                    this.state.showExitBtn || (appHelper.isDefined(this.props.contentData.experience.return_to_portal_on_exit) && this.props.contentData.experience.return_to_portal_on_exit)
                                        ?
                                        <div className="flex-item">
                                            <ExitBtn disabled={this.geKpiBtnDisabled()}/>
                                        </div>
                                        : null
                                }
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
            </div>



        );
    }
}

//<div>{document.getElementById('main-wrapper').clientWidth.toString()} * {document.getElementById('main-wrapper').clientHeight.toString()}</div>
ScenarioBiteHeaderMobile.propTypes = {
    lang: PropTypes.string.isRequired,
    bite: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    dialogPopup: PropTypes.object.isRequired,
    assetDialog: PropTypes.object.isRequired,
    screenDialog: PropTypes.object.isRequired,
    displayMainMenu: PropTypes.string.isRequired,
    displayResources: PropTypes.string.isRequired,
    titles: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

ScenarioBiteHeaderMobile.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        trackingData: state.trackingData,
        contentData: state.contentData,
        userData: state.userData,
        titles: state.titles,
        dialogPopup: state.dialogPopup,
        assetDialog: state.assetDialog,
        screenDialog: state.screenDialog,
        displayMainMenu: state.displayMainMenu,
        displayResources: state.displayResources

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioBiteHeaderMobile);


/** WEBPACK FOOTER **
 ** ./src/components/bites/ScenarioBite/ScenarioBiteHeaderMobile.js
 **/